export default __webpack_public_path__ + "static/media/27.02f06663.png";